export const tiposItem = [
  ["veiculo", "Veículo"],
  ["arma_fogo", "Arma de fogo"],
  ["arma_branca", "Arma branca"],
  ["droga", "Droga"],
  ["outro_objeto", "Outros objetos/bens"],
];

export const tiposArmaBranca = [
  "Faca",
  "Facão",
  "Canivete",
  "Punhal",
  "Espada",
  "Machado",
  "Foice",
  "Instrumento perfurocortante",
  "Outro",
];

export const estadosConservacaoArmaBranca = [
  ["integro", "Íntegro"],
  ["danificado", "Danificado"],
  ["outro", "Outro"],
];

export const tiposDroga = [
  "Anfetamina",
  "Cocaína",
  "Crack",
  "Ecstasy",
  "Haxixe",
  "Lança-perfume",
  "LSD",
  "Maconha",
  "Oxi",
  "Pasta base",
  "Pé de maconha",
  "Outra droga",
];

export const unidadesOutraDroga = ["g", "ml", "frasco", "unidade", "comprimido"];

const unidadesPadraoDroga = {
  Anfetamina: "g",
  Cocaína: "g",
  Crack: "g",
  Ecstasy: "comprimido",
  Haxixe: "g",
  "Lança-perfume": "frasco",
  LSD: "microponto",
  Maconha: "g",
  Oxi: "g",
  "Pasta base": "g",
  "Pé de maconha": "unidade",
};

export const participacoes = [
  ["apreendido", "Apreendido"],
  ["encontrado", "Encontrado"],
  ["subtraido", "Subtraído"],
  ["apreendido_infracao_transito", "Apreendido por infração de trânsito"],
];

export const unidadesFederativas = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS",
  "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC",
  "SP", "SE", "TO",
];

export const criarMaterialVazio = (tipoItem = "") => {
  const base = { tipoItem };
  if (tipoItem === "veiculo") {
    return {
      ...base,
      dadosVeiculo: {
        pais: "",
        placa: "",
        uf: "",
        renavam: "",
        chassi: "",
        municipioRegistro: "",
        situacaoRegistro: "",
        especie: "",
        tipoVeiculo: "",
        marca: "",
        modelo: "",
        categoria: "",
        corPredominante: "",
        anoFabricacao: "",
        anoModelo: "",
        situacaoAdministrativa: "",
        proprietario: "",
        participacoes: [],
      },
    };
  }
  if (tipoItem === "arma_fogo") {
    return {
      ...base,
      dadosArma: {
        especie: "",
        marca: "",
        modelo: "",
        acabamento: "",
        quantidadeCanos: "",
        fabricacao: "",
        tipoUso: "",
        calibreReal: "",
        numeroRegistro: "",
        numeroSerie: "",
        situacaoNumeroSerie: "",
        participacoes: [],
        informacoesCarga: false,
      },
    };
  }
  if (tipoItem === "arma_branca") {
    return {
      ...base,
      dadosArmaBranca: {
        tipoArmaBranca: "",
        descricao: "",
        quantidade: "",
        marca: "",
        materialFabricacao: "",
        comprimentoAproximadoCm: "",
        caracteristicasDistintivas: "",
        estadoConservacao: "",
        observacoes: "",
        participacoes: [],
      },
    };
  }
  if (tipoItem === "droga") {
    return {
      ...base,
      dadosDroga: {
        tipoDroga: "",
        substancia: "",
        quantidade: "",
        unidade: "",
        participacoes: [],
        informacoesCarga: false,
        observacoes: "",
      },
    };
  }
  if (tipoItem === "outro_objeto") {
    return {
      ...base,
      dadosObjeto: {
        tipoObjeto: "",
        quantidade: "",
        unidade: "",
        participacoes: [],
        observacoes: "",
      },
    };
  }
  return base;
};

export const materialParaFormulario = (material) => {
  if (material?.tipoItem) return material;
  if (material && (material.descricao || material.quantidade)) {
    return {
      ...criarMaterialVazio("outro_objeto"),
      dadosObjeto: {
        ...criarMaterialVazio("outro_objeto").dadosObjeto,
        tipoObjeto: material.descricao || "",
        quantidade: material.quantidade || "",
        unidade: material.unidade || "",
      },
    };
  }
  return criarMaterialVazio();
};

export const atualizarTipoDroga = (material, tipoDroga) => {
  const dadosDroga = { ...(material.dadosDroga || {}), tipoDroga };
  if (tipoDroga === "Outra droga") {
    if (!unidadesOutraDroga.includes(dadosDroga.unidade)) dadosDroga.unidade = "g";
  } else {
    dadosDroga.unidade = unidadesPadraoDroga[tipoDroga] || "";
    dadosDroga.substancia = "";
  }
  return { ...material, dadosDroga };
};

export const validarMaterial = (material) => {
  const erro = (campo, mensagem) => ({ campo, mensagem });
  if (!tiposItem.some(([tipo]) => tipo === material?.tipoItem)) {
    return erro("tipoItem", "Selecione o tipo de item.");
  }
  if (material.tipoItem === "veiculo") {
    const dados = material.dadosVeiculo || {};
    if (['brasil', 'brazil', 'br'].includes(String(dados.pais || '').trim().toLowerCase()) && dados.placa &&
      !/^[a-z]{3}[- ]?\d[a-z0-9]\d{2}$/i.test(String(dados.placa).trim())) {
      return erro('dadosVeiculo.placa', 'Informe uma placa brasileira válida (ABC-1234 ou ABC1D23).');
    }
    if (!dados.situacaoRegistro) {
      return erro("dadosVeiculo.situacaoRegistro", "Informe a situação de registro.");
    }
    if (dados.situacaoRegistro === "sem_registro" && !dados.chassi?.trim()) {
      return erro("dadosVeiculo.chassi", "Informe o chassi para veículo sem registro.");
    }
    if (dados.situacaoRegistro === "registrado" &&
      !dados.placa?.trim() && !dados.renavam?.trim() && !dados.chassi?.trim()) {
      return erro("dadosVeiculo.placa", "Informe pelo menos placa, RENAVAM ou chassi.");
    }
  }
  if (material.tipoItem === "arma_fogo") {
    const dados = material.dadosArma || {};
    if (material.quantidade !== undefined && material.quantidade !== null && material.quantidade !== '' &&
      (!['number', 'string'].includes(typeof material.quantidade) || (typeof material.quantidade === 'string' && !/^\d+(?:\.0+)?$/.test(material.quantidade.trim())) || !Number.isSafeInteger(Number(material.quantidade)) || Number(material.quantidade) < 1)) {
      return erro('quantidade', 'Informe uma quantidade inteira positiva de armas ou deixe em branco se desconhecida.');
    }
    if (!dados.especie?.trim()) return erro("dadosArma.especie", "Informe a espécie da arma.");
    if (!["suprimido", "nao_identificado"].includes(dados.situacaoNumeroSerie) && !dados.numeroSerie?.trim()) {
      return erro("dadosArma.numeroSerie", "Informe o número de série ou indique que foi suprimido.");
    }
    if (dados.quantidadeCanos && (!Number.isInteger(Number(dados.quantidadeCanos)) || Number(dados.quantidadeCanos) < 1)) {
      return erro("dadosArma.quantidadeCanos", "Informe uma quantidade inteira válida.");
    }
  }
  if (material.tipoItem === "arma_branca") {
    const dados = material.dadosArmaBranca || {};
    if (!tiposArmaBranca.includes(dados.tipoArmaBranca)) {
      return erro("dadosArmaBranca.tipoArmaBranca", "Selecione o tipo de arma branca.");
    }
    if ((typeof dados.quantidade !== "number" && typeof dados.quantidade !== "string") ||
      (typeof dados.quantidade === "string" && !dados.quantidade.trim()) ||
      !Number.isInteger(Number(dados.quantidade)) || Number(dados.quantidade) < 1) {
      return erro("dadosArmaBranca.quantidade", "Informe uma quantidade inteira positiva.");
    }
    const limitesTexto = {
      descricao: 500,
      marca: 120,
      materialFabricacao: 120,
      caracteristicasDistintivas: 500,
      observacoes: 1000,
    };
    for (const [campo, limite] of Object.entries(limitesTexto)) {
      const valor = dados[campo];
      if (valor !== undefined && valor !== null &&
        (typeof valor !== "string" || valor.length > limite)) {
        return erro(`dadosArmaBranca.${campo}`, `O campo deve ter no máximo ${limite} caracteres.`);
      }
    }
    if (dados.comprimentoAproximadoCm !== "" && dados.comprimentoAproximadoCm !== undefined &&
      ((typeof dados.comprimentoAproximadoCm !== "number" &&
        typeof dados.comprimentoAproximadoCm !== "string") ||
        (typeof dados.comprimentoAproximadoCm === "string" && !dados.comprimentoAproximadoCm.trim()) ||
        !Number.isFinite(Number(dados.comprimentoAproximadoCm)) ||
        Number(dados.comprimentoAproximadoCm) <= 0)) {
      return erro("dadosArmaBranca.comprimentoAproximadoCm", "Informe um comprimento positivo em centímetros.");
    }
    if (dados.estadoConservacao && !estadosConservacaoArmaBranca.some(([value]) => value === dados.estadoConservacao)) {
      return erro("dadosArmaBranca.estadoConservacao", "Selecione um estado de conservação válido.");
    }
  }
  if (material.tipoItem === "droga") {
    const dados = material.dadosDroga || {};
    if (!dados.tipoDroga) return erro("dadosDroga.tipoDroga", "Selecione o tipo de droga.");
    if (dados.tipoDroga === "Outra droga" && !dados.substancia?.trim()) {
      return erro("dadosDroga.substancia", "Informe qual é a outra droga.");
    }
    if (!Number.isFinite(Number(dados.quantidade)) || Number(dados.quantidade) <= 0) {
      return erro("dadosDroga.quantidade", "Informe uma quantidade maior que zero.");
    }
    const unidadeEsperada = unidadesPadraoDroga[dados.tipoDroga];
    if (unidadeEsperada && dados.unidade !== unidadeEsperada) {
      return erro("dadosDroga.unidade", "A unidade é definida pelo tipo de droga selecionado.");
    }
    if (dados.tipoDroga === "Outra droga" && !unidadesOutraDroga.includes(dados.unidade)) {
      return erro("dadosDroga.unidade", "Selecione uma unidade permitida.");
    }
  }
  if (material.tipoItem === "outro_objeto") {
    const dados = material.dadosObjeto || {};
    if (!dados.tipoObjeto?.trim()) return erro("dadosObjeto.tipoObjeto", "Informe o tipo de objeto/bem.");
    if (!Number.isFinite(Number(dados.quantidade)) || Number(dados.quantidade) <= 0) {
      return erro("dadosObjeto.quantidade", "Informe uma quantidade maior que zero.");
    }
    if (!dados.unidade?.trim()) return erro("dadosObjeto.unidade", "Informe a unidade de medida.");
  }
  return null;
};
